import {
  Button,
  TableRow,
  MenuItem,
  TableCell,
  Typography,
  IconButton,
  ListItemText,
} from '@mui/material';

import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { fNumber } from 'src/utils/format-number';
import { ProductAmountConfigType } from 'src/type/product-amount-config';

type Props = {
  loading: boolean;
  row: ProductAmountConfigType;
  onEdit: VoidFunction;
  onDelete: VoidFunction;
};

export default function ProductAmountTableRow({ loading, row, onEdit, onDelete }: Props) {
  const { name, weightBaht, weightGram } = row;
  const popover = usePopover();
  const confirm = useBoolean();

  return (
    <>
      <TableRow>
        <TableCell>
          <ListItemText
            disableTypography
            primary={
              <Typography variant="body2" noWrap>
                {name}
              </Typography>
            }
          />
        </TableCell>

        <TableCell>{fNumber(weightBaht, 4)}</TableCell>

        <TableCell>{fNumber(weightGram, 4)}</TableCell>

        <TableCell align="right" sx={{ px: 2 }}>
          <IconButton
            color={popover.open ? 'inherit' : 'default'}
            onClick={popover.onOpen}
            disabled={loading}
          >
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="top-right"
        sx={{ width: 160 }}
      >
        <MenuItem
          onClick={() => {
            popover.onClose();
            onEdit();
          }}
        >
          <Iconify icon="solar:pen-bold-duotone" />
          แก้ไข
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
            confirm.onTrue();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          ลบ
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="ลบสินค้า"
        content={`คุณต้องการลบสินค้า ${row.name} ใช่หรือไม่?`}
        action={
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              onDelete();
              confirm.onFalse();
            }}
          >
            ยืนยันการลบ
          </Button>
        }
      />
    </>
  );
}
